import type { NextPage } from 'next'
import Head from 'next/head'
import { Headline2 } from '@/components/common/Headline2'
import { PlanetDecor } from '@/components/decors/PlanetDecor'
import { CallToAction } from '@/components/common/CallToAction'
import { CardBlock } from '@/components/common/CardBlock'
import { ContactForm } from '@/components/forms/ContactForm'
import Phone from '@/components/icons/Phone'
import Location from '@/components/icons/Location'

import { ImageLoaderProps } from 'next/image'
import contact_page from '@/public/svg/contact_page.svg'
import contact_page_img from '@/public/images/site-preview.gif'
import Image from 'next/image'
import { Breadcrumbs } from '@/components/navigation/Breadcrumbs'

const loader = ({ src, width, quality }: ImageLoaderProps) => {
  return `${process.env.NEXT_PUBLIC_SITE}${src}?w=${width}&q=${quality || 75}`
}

const Page: NextPage = () => {

  return (
    <>
      <Head>
        <title>Get In Touch With Us | Commit Action</title>
        <meta name="description" content="Got a question about Commit Action? We’re here to help and would love to hear from you." />
        <link rel="canonical" href={`${process.env.NEXT_PUBLIC_SITE}/contact/`} />
        <meta property="og:url" content={`${process.env.NEXT_PUBLIC_SITE}/contact/`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Get In Touch With Us | Commit Action" />
        <meta property="og:description" content="Got a question about Commit Action? We’re here to help and would love to hear from you." />
        <meta property="og:image" content={`${process.env.NEXT_PUBLIC_SITE}${contact_page_img.src}`} />
        <meta name="twitter:title" content="Get In Touch With Us | Commit Action" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:description" content="Got a question about Commit Action? We’re here to help and would love to hear from you."/>
        <meta name="twitter:image" content={`${process.env.NEXT_PUBLIC_SITE}${contact_page_img.src}`} />
      </Head>
      <Breadcrumbs values={[{
        name: 'Contact'
      }]}/>
      <div className="container flex flex-col lg:flex-row tiny:pt-[100px]">
        <div className="w-full order-2 sm2:w-[80%] sm2:min-w-[500px] max-w-[560px] larger:max-w-none lg:w-[41%] mt-160-to-220">
          <Headline2 tag="h1" className="text-46-to-60 mb-[40px]">Contact Us</Headline2>
          <p className="text-18-to-20">Got a question about Commit Action? We’re here to help and would love to hear from you. Please fill out this form and we will get in touch with you shortly.</p>
          <div className="mt-[40px] md:mt-[60px] max-w-[600px]">
            <CardBlock styleSecondary={true}>
              <ContactForm/>
            </CardBlock>
            <div className="contact-info mt-[40px] md:mt-[60px]">
              <h2 className="text-22-to-29">Commit Action Corporate office</h2>
              <p className="text-14-to-18 mb-[30px]">(For all customer support please use the form above)</p>
              <div className="contact-info__item text-18-to-20">
                <Location></Location>
                <div className="contact-info__text">
                  <p>Commit Action Inc,</p>
                  <p>487 E Main St Suite 144</p>
                  <p>Mount Kisco, New York 10549 USA</p>
                </div>
              </div>
              <div className="contact-info__item text-18-to-20">
                <Phone></Phone>
                <div className="contact-info__text">
                  <p><a href="tel:+19178196259">+1 (917) 819-6259</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full order-1 lg:order-2 lg:w-[50%] lg:relative">
          <div className="absolute right-[-120px] larger:right-0 top-[-180px] lg:top-[40px] larger:top-[7%] w-[100%] sm2:w-[70%] lg:w-[460px] 2xl:w-[520px] z-[-1]">
            <Image
              loader={loader}
              src={contact_page}
              alt="contact page image"
              priority={true}
            />
          </div>
        </div>
      </div>
      <div>
        <CallToAction title="Achieve Your Goals Faster" />
      </div>
      <PlanetDecor className="top-[-300px] h-[1200px] z-[-1] lg:top-[-560px]" style={{transform: 'rotate(180deg)'}}/>
    </>
  )
}

export default Page
